import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'

import { copyToClipboard } from './utils'

import css from './styles.css'

const CopyButton = ({ buttonText, copied, setCopied, strToCopy }) => (
  <div className={css.copyButtonContainer} >
    <Button
      onClick={() => {
        copyToClipboard(strToCopy)
        setCopied()
      }}
    >
      {buttonText}
    </Button>
    {copied && <span className={css.copied}>Successfully copied</span>}
  </div>
)

CopyButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  copied: PropTypes.bool.isRequired,
  setCopied: PropTypes.func.isRequired,
  strToCopy: PropTypes.string.isRequired,
}

export default CopyButton



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/CopyButton.js